import Action from "@/action/Action"
import { applicationState, providerState } from "@/state"
import router from "@/router"
import { flowService } from "@/service"
import accountState from "@/state/AccountState.js"

/**
 * Base action that is expected to potentially resume.
 */
class BaseResumeAction extends Action {

    providerKey = null

    constructor(id, providerKey) {
        super(id)
        this.providerKey = providerKey
    }

    async invoke() {
        if (applicationState.resume?.responseCode === "open") {
            await router.replace(`/providers/${this.providerKey}/resume/from-open`)
            return
        }

        const preauthResponse = providerState.getPreAuthResponse(this.providerKey)
        let applyResponse = providerState.getApplyResponse(this.providerKey)

        if (applyResponse?.responseCode === "error") {
            applyResponse = null
        }

        if (!this.isResumable(preauthResponse, applyResponse)) {
            await flowService.restartFlow().then(() => {
                router.replace("/")
            })
            return
        }

        //Setting existing account
        if (preauthResponse?.existingAccount && preauthResponse?.availableBalanceCents) {
            accountState.account = {
                providerKey: preauthResponse.providerKey,
                creditLimitCents: preauthResponse.approvedAmountCents,
                availableAmountCents: preauthResponse.availableBalanceCents,
            }
        }

        await this.handleNavigation(preauthResponse, applyResponse)
    }

    isResumable(preauthResponse, applyResponse) {
        throw new Error("Not Implemented")
    }

    async handleNavigation(preauthResponse, applyResponse) {
        throw new Error("Not Implemented")
    }
}

export default BaseResumeAction
